import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'monorepo-preview-images',
  templateUrl: './preview-images.component.html',
  styleUrls: ['./preview-images.component.scss'],
})
export class PreviewImagesComponent implements OnInit {
  @Input() publicPaths: string[] = [];
  isSingleImagePreviewMode = false;
  previewSingleImagePublicPath: string | undefined;
  backArrow = '/assets/md-point/header-back-arrow.svg';
  constructor(private modalController: ModalController) {}

  ngOnInit(): void {}

  handleBack() {
    this.modalController.dismiss();
  }

  previewImage(publicPath: string) {
    this.previewSingleImagePublicPath = publicPath;
    this.isSingleImagePreviewMode = true;
  }

  goToViewAllImages() {
    this.previewSingleImagePublicPath = undefined;
    this.isSingleImagePreviewMode = false;
  }
}
